import * as Immutable from "immutable";
import FileTrait from "./trait.file.jsx";

const AttachmentRecord = Immutable.Record({
  id: 0,
  class: ``,
  type: ``,
  name: ``,
  sizeValue: 0,
  thumbnail_url: ``,
  preview_url: ``,
  download_url: ``,
  created_by_id: 0,
  created_on: 0,
  disposition: `attachment`,
  mime_type: ``,
  folder_id: null,
  project_id: 0,
  parent_type: ``,
  parent_id: 0,
  created_by_name: ``,
  extension: ``,
  file_type: ``,
  code: ``,
});

class Attachment extends AttachmentRecord {
  constructor(data) {
    super(data);
    this.isDropboxFile = FileTrait.isDropboxFile.bind(this);
    this.isGoogleDriveFile = FileTrait.isGoogleDriveFile.bind(this);
    this.isLocalFile = FileTrait.isLocalFile.bind(this);
    this.isWarehouseFile = FileTrait.isWarehouseFile.bind(this);
    this.getThumbnailUrl = FileTrait.getThumbnailUrl.bind(this);
    this.getSize = FileTrait.getSize.bind(this);
  }
}

export default Attachment;
